import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const SiteAbortApprovalsList = ({
  approvalList,
  getSiteAbortApproval,
  acceptSiteStatusApproval,
  rejectAbortApproval,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState();
  const [isModal, setIsModal] = useState(false);
  const [actionData, setActionData] = useState();
  const [isSuccessModel, setIsSuccessModel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    if (getSiteAbortApproval !== null) {
      (async () => {
        setIsLoading(true);
        await getSiteAbortApproval();
        setIsLoading(false);
      })();
    }
  }, [getSiteAbortApproval]);

  const Headers = [
    'Site No',
    'Site Name',
    'Requested By',
    'Status',
    'Remark',
    'Requested On',
    'Approve',
  ];

  useEffect(() => {
    const tableData = [
      'id',
      'site_no',
      'site_name',
      'name',
      'statusName',
      'remark',
      'created_at',
      'approval_status_id'
    ];

    if (approvalList !== {} && approvalList.data) {
      const data = approvalList.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
              {
                'Approve/Reject': '',
               
              }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(approvalList.total / approvalList.per_page));
    }
  }, [approvalList]);

  const updateApproval = async (data) => { 
    var statusArr = [17,24,25,27];
    var status = 1;
    if(statusArr.includes(data.actionObj.approval_status_id)) {
       status = 3;
    }
    // console.log(data.actionObj); return false;
    setActionData(data);
    if (data.action === 'accept') {
      setIsLoading(true);
      await acceptSiteStatusApproval(data.actionObj.id,status,data.actionObj.approval_status_id).then(async (response) => {
        if (response) {
          await getSiteAbortApproval();
          setIsLoading(false);
          setIsModal(true);
        }
      });
    } else {
      setIsLoading(false);
      setIsModal(true);
    }
    setIsLoading(false);
  };

  const handleModalHide = () => setIsModal(false);

  const successIconBox = (text, func) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{text}</h5>
        <Button onClick={func} className="btn btn-transparent">
          {localization.returnToApproval}{' '}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getSiteAbortApproval(val.selected + 1);
    setIsLoading(false);
  };

  const handleRejection = async (info) => {
    // console.log(info); return false;
    setIsModal(false);
    if (info.action === 'reject') {
      setIsLoading(true);
      await rejectAbortApproval(info.actionObj.id,info.actionObj.approval_status_id).then(async (response) => {
        if (response) {
          await getSiteAbortApproval();
          setIsLoading(false);
          setIsSuccessModel(true);
        }
      });
    }
  };

  return (
    <Layout title={localization.siteAbortApproval} isLoading={isLoading}>
      <TableSection
        data={listData}
        headers={Headers}
        detailList={approvalList && approvalList.resultSets}
        onChange={(data) => updateApproval(data)}
        pageCount={pageCount}
        onPageChange={onPageChange}
        isId={false}
        isStatusId={false}
        srNo={approvalList?.from}
      />
      {console.log(approvalList)}
      <ModalPop
        title={
          actionData && actionData.action === 'reject'
            ? localization.rejectConf
            : localization.conf
        }
        show={isModal}
        handleModalHide={() => setIsModal(false)}
        actionData={actionData}
      >
        {actionData && actionData.action === 'reject' ? (
          <div className="modal-body">
            <div className="text-center">
              <h5>Are you sure you want to reject?</h5>
              <Button
                className="btn btn-primary mb-4"
                onClick={() => handleRejection(actionData)}
              >
                {localization.continue} <img src={Images?.ArrowRight} alt="" />
              </Button>
              <Button
                onClick={() => setIsModal(false)}
                className="btn btn-transparent"
              >
                {localization.returnToApproval}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Button>
            </div>
          </div>
        ) : (
          successIconBox(localization.approvedSuccess, handleModalHide)
        )}
      </ModalPop>
      <ModalPop
        title={localization.rejectSuccessfully}
        show={isSuccessModel}
        handleModalHide={() => setIsSuccessModel(false)}
      >
        {successIconBox(localization.siteAbortApproval, () =>
          setIsSuccessModel(false)
        )}
      </ModalPop>
    </Layout>
  );
};

SiteAbortApprovalsList.propTypes = {
  approvalList: PropTypes.any,
  getSiteAbortApproval: PropTypes.any,
  acceptSiteStatusApproval: PropTypes.any,
  rejectAbortApproval: PropTypes.func,
};

export default SiteAbortApprovalsList;
